import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

type AppRole = 'admin' | 'tester' | 'user';

export const useUserRole = () => {
  const { user } = useAuth();

  const { data: roles, isLoading } = useQuery({
    queryKey: ['userRoles', user?.id],
    queryFn: async () => {
      if (!user) return [] as AppRole[];

      const { data, error } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', user.id);

      if (error) {
        console.error('Error fetching user roles:', error);
        return [] as AppRole[];
      }

      return (data?.map((r) => r.role) ?? []) as AppRole[];
    },
    enabled: !!user,
  });

  const roleSet = new Set(roles ?? []);

  return {
    isAdmin: roleSet.has('admin'),
    isTester: roleSet.has('tester'),
    isLoading,
  };
};

